'use client';

import { FC, useRef } from 'react';
import communityDefaultIcon from 'components/icons/communityDefaultWhite.png'

import { JoinButton } from 'components/landing/JoinButton';
import { useIsVisible } from 'hooks/useIsVisible';
import Img from 'next/image';
import { Button } from '../ui/button';
import Link from 'next/link';

interface ILandingHeader {
  logo: string;
  name: string;
  secondaryUrl?: string | null;
  headerSecondaryUrlTitle?: string | null;
}

export const LandingHeader: FC<ILandingHeader> = ({ logo, name, secondaryUrl, headerSecondaryUrlTitle }) => {
  const logoRef = useRef(null);
  const joinButtonRef = useRef(null);

  const isVisibleLogo = useIsVisible(logoRef);
  const isVisibleJoinButton = useIsVisible(joinButtonRef);

  return (
    <header className="flex justify-center bg-purple-blue px-10 sm-1/2:px-5">
      <div className="container">
        <div className="py-9 flex justify-between">
          <div
            ref={logoRef}
            className={`flex gap-2 items-center transition-all duration-1000 ${isVisibleLogo ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-1.5'}`}
          >
            <Img
              className="max-h-11"
              src={logo || communityDefaultIcon}
              alt="Community Logo"
              width={44}
              height={44}
            />
            <p className="m-0 font-poppins text-white">{name}</p>
          </div>
          <div
            ref={joinButtonRef}
            className={`flex gap-2 justify-between duration-1000 transition-all ${isVisibleJoinButton ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-full'}`}
          >
            {secondaryUrl && (
              <Button
                size="lg"
                variant="outline"
                className="text-white hover:bg-white hover:text-purple-blue"
                asChild
              >
                <Link href={secondaryUrl} target="_blank">
                  {headerSecondaryUrlTitle}
                </Link>
              </Button>
            )}
            <JoinButton location="header" />
          </div>
        </div>
      </div>
    </header>
  );
};
